import { computed } from "mobx";
import { inject, observer } from "mobx-react";

import Ghost from "./Ghost";
import Real from "./Real";

const Step4 = inject("mainStore")(
    observer(({ mainStore, setStep, step, countOfSteps }) => {
        const detailData = computed(() => mainStore.getMainStore("detailData")).get();

        const Specified = detailData.ghostOffer ? Ghost : Real;

        return <Specified setStep={setStep} step={step} countOfSteps={countOfSteps} />;
    }),
);

export default Step4;
